import type { Application } from 'merchant-api/types';

/**
 * The run-once gate for PROVE_STEP (XF-10207), kept free of import.meta / router imports so it is
 * unit-testable on its own and shared by the step mapper (first-visit routing + reload) and the step
 * itself (self-skip).
 *
 * Show PROVE_STEP only when the applicant is in the M3 test bucket AND provePrefillConsent is unset.
 * prove/complete writes provePrefillConsent, so a successful run turns the step off durably — on a
 * hard reload while the application is still STARTED, this returns false and the mapper falls through
 * to the regular form step (which LoanAppForm then maps to OWNER_STEP for consented applications).
 */
export const hasProvePrefillConsent = (app?: Pick<Application, 'data'> | null): boolean =>
  Boolean(app?.data?.provePrefillConsent);

export const shouldShowProveStep = (app: Pick<Application, 'data'> | null | undefined, proveStepEligible?: boolean): boolean =>
  proveStepEligible === true && !hasProvePrefillConsent(app);
